import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { loadAndAssert } from '../authz/access.js';
import { Conversation } from '../conversation.js';

export const clearPendingSettingsChangeMutation = registerMutation({
  operationName: 'clearPendingSettingsChange',
  type: () => Boolean,
  params: [{ name: 'conversationId', type: () => String }],
  resolve: (conversationId: string) => async () => {
    // Raw update by id — no publishFilter — so the caller must own the conversation.
    await loadAndAssert(Conversation, conversationId, 'update', { _id: 1 });
    await (
      await getRawCollection(Conversation._collectionName)
    ).updateOne({ _id: conversationId } as any, { $unset: { pendingSettingsChange: '' } });
    return true;
  },
});
